import * as ReactDOM from "react-dom";
import * as React from "react";
import { createRoot } from "react-dom/client";
import "./main.css";

import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./auth/OidcAuthProvider";

declare global {
    const Server: string;
    const ShopServer: string;
    const IdentityClientID: string;
    const IdentityAuthority: string;
}

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.fetchData;
const container = document.getElementById("app");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
    <Router>
        <AuthProvider>
            <App />
        </AuthProvider>
    </Router>
);
